import { Text, VStack } from 'native-base';
import React from 'react';
import BorderedCard from '../../BorderedCard';
import NewLoanInProgressHeader from '../NewLoanInProgressHeader';
export const StatusUnderReview = () => {
  return /*#__PURE__*/React.createElement(BorderedCard, {
    padding: 3
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 7
  }, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
    header: "Loan Status"
  }), /*#__PURE__*/React.createElement(Text, {
    mb: 9,
    color: "black.200",
    accessibilityLabel: "Your application is currently under review. Please check back later.",
    testID: "under_review"
  }, "Your application is currently under review. Please check back later.")));
};
//# sourceMappingURL=index.js.map